var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{attrs:{"mensaje":_vm.datoRecibido}}),_c('main',{staticClass:"content"},[_c('router-view',{on:{"datoEnviado":_vm.recibirDato}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }